import { useStores } from 'models';
import { RunModel, RunModelModel } from 'models/RunModel/RunModel';
import { useState } from 'react';
import { dateToRecordId } from 'services/freak_estimator/OnlineAPI';
import { useFSM } from 'services/DongleController/DongleController';
import { deviceIdFromEntry, getVideoFileName } from '../../util';

const useRunBaseData = () => {
  const FSM = useFSM();
  const [baseData, setBaseData] = useState<RunModel | null>(null);
  const { currentUser } = useStores();
  const rootStore = useStores();

  const createNewRun = async (hasVideo = false) => {
    const bleDevice = FSM.bleDevice.get();
    if (!bleDevice || !bleDevice.entry) {
      throw new Error('No bluetooth device for trick');
    }

    const deviceId = deviceIdFromEntry(bleDevice.entry);
    const date = new Date();
    const recordId = dateToRecordId(date);

    const newRun: RunModel = RunModelModel.create(
      {
        id: `${deviceId}_${recordId}`,
        deviceId,
        recordId,
        date,
        shareUrl: '',
        skater: currentUser?.displayName ?? 'N/A',
      },
      rootStore.environment
    );
    if (hasVideo)
      newRun.setLocalVideoName(getVideoFileName(deviceId, recordId));
    setBaseData(() => newRun);
    return newRun;
  };

  return { createNewRun, baseData };
};

export default useRunBaseData;
